import { render } from "./B2bTableAuditoriaAcciones.vue?vue&type=template&id=084fc221&scoped=true&lang=pug"
import script from "./B2bTableAuditoriaAcciones.vue?vue&type=script&lang=js"
export * from "./B2bTableAuditoriaAcciones.vue?vue&type=script&lang=js"

import "./B2bTableAuditoriaAcciones.vue?vue&type=style&index=0&id=084fc221&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084fc221"]])

export default __exports__